/**
 * ParentUpgradePlan.js — full pricing matrix embedded in the parent shell.
 * Reuses /pages/PricingPage.js in its `embedded` mode so the cards
 * (ENTRY · CHALLENGER · THE ELITE · MASTER), live family-pricing stepper,
 * trial banner and Hearts/Help cards stay 1-for-1 identical to /pricing.
 */
import React from 'react';
import { ParentShell } from '../components/parent/ParentShell';
import PricingPage from './PricingPage';

const ParentUpgradePlan = () => (
  <ParentShell activeId="upgrade" title="Upgrade Plan">
    <PricingPage embedded />
  </ParentShell>
);

export default ParentUpgradePlan;
